import EntityType from '@/shared/enums/EntityType';

const activitySummaryDimension = {
  id: `${EntityType.ACTIVITY}`,
  label: 'Activity',
  order: [EntityType.ACTIVITY, EntityType.ROLE],
};

const organisationDimensions = [
  {
    id: `${EntityType.GROUP}:${EntityType.ROLE}:${EntityType.PERSON}`,
    label: 'Activity > Team > Role > Person',
    order: [
      EntityType.ACTIVITY,
      EntityType.GROUP,
      EntityType.ROLE,
      EntityType.PERSON,
    ],
  },
  {
    id: `${EntityType.ROLE}:${EntityType.GROUP}:${EntityType.PERSON}`,
    label: 'Activity > Role > Team > Person',
    order: [
      EntityType.ACTIVITY,
      EntityType.ROLE,
      EntityType.GROUP,
      EntityType.PERSON,
    ],
  },
  {
    id: `${EntityType.ROLE}:${EntityType.PERSON}:${EntityType.GROUP}`,
    label: 'Activity > Role > Person > Team',
    order: [
      EntityType.ACTIVITY,
      EntityType.ROLE,
      EntityType.PERSON,
      EntityType.GROUP,
    ],
  },
  {
    id: `${EntityType.GROUP}:${EntityType.ROLE}:${EntityType.ACTIVITY}:${EntityType.PERSON}`,
    label: 'Team > Role > Activity > Person',
    order: [
      EntityType.GROUP,
      EntityType.ROLE,
      EntityType.ACTIVITY,
      EntityType.PERSON,
    ],
  },
  {
    id: `${EntityType.GROUP}:${EntityType.ACTIVITY}:${EntityType.ROLE}:${EntityType.PERSON}`,
    label: 'Team > Activity > Role > Person',
    order: [
      EntityType.GROUP,
      EntityType.ACTIVITY,
      EntityType.ROLE,
      EntityType.PERSON,
    ],
  },
  {
    id: `${EntityType.ROLE}:${EntityType.ACTIVITY}:${EntityType.PERSON}:${EntityType.GROUP}`,
    label: 'Role > Activity > Person > Team',
    order: [
      EntityType.ROLE,
      EntityType.ACTIVITY,
      EntityType.PERSON,
      EntityType.GROUP,
    ],
  },
  {
    id: `${EntityType.ROLE}:${EntityType.GROUP}:${EntityType.ACTIVITY}:${EntityType.PERSON}`,
    label: 'Role > Team > Activity > Person',
    order: [
      EntityType.ROLE,
      EntityType.GROUP,
      EntityType.ACTIVITY,
      EntityType.PERSON,
    ],
  },
];

const roleDimensions = [
  {
    id: `${EntityType.ROLE}`,
    label: 'Role',
    order: [EntityType.ACTIVITY, EntityType.ROLE],
  },
];

const ActivityDimensions = {
  [EntityType.ACTIVITY]: activitySummaryDimension,
  [EntityType.GROUP]: organisationDimensions,
  [EntityType.MANAGER]: organisationDimensions,
  [EntityType.ORGANISATION]: organisationDimensions,
  [EntityType.ROLE]: roleDimensions,
};

export default ActivityDimensions;
